const DOT_MARKER_POI_TYPES = ['carParks', 'gasStations', 'camera'] // types that actually should be shown as dots
const HAS_DOT_MARKER_POI_TYPES = ['carParks', 'gasStations', 'traffic'] // main POI categories that might have dot subtypes
const ZOOM_LEVEL_POI_TYPES = ['traffic']

export function isDotMarker(poiType, isFavourite = false, hasText = false) {
    const isDot = DOT_MARKER_POI_TYPES.includes(poiType) && !isFavourite

    if(poiType === 'gasStations' && hasText) return false

    return isDot
}

export function hasDotMarkerType(poiType) {
    return HAS_DOT_MARKER_POI_TYPES.includes(poiType)
}

export function isZoomLevelBasedType(poiType) {
    return ZOOM_LEVEL_POI_TYPES.includes(poiType)
}

export function getZoomLevelVisible(/* poiType, poiData */) {
    // let zoomLevel = false
    // if(poiType === 'traffic') {
    //     if(poiData.road && poiData.road.roadClass) {
    //         switch(poiData.road.roadClass) {
    //             case 1:
    //                 zoomLevel = 5
    //                 break
    //             case 3:
    //                 zoomLevel = 8
    //                 break
    //             case 4:
    //                 zoomLevel = 10
    //                 break
    //             case 5:
    //                 zoomLevel = 11
    //                 break
    //             case 7:
    //                 zoomLevel = 12
    //                 break
    //         }
    //     } 
    // }
    // return zoomLevel
    return false
}

export function getAreas(poiResult) {
    if(poiResult.data && poiResult.data.geoData && poiResult.data.geoData.wkt) {
        return [
            {
                area: poiResult.data.geoData.wkt
            }
        ]
    } else if(poiResult.data && (poiResult.data.polygon3WKT || poiResult.data.polygon2WKT || poiResult.data.polygonWKT)) {
        let areas = []
        if(poiResult.data.polygonWKT && !poiResult.data.polygonWKT.includes('EMPTY')) {
            areas.push({
                area: poiResult.data.polygonWKT,
                level: 1
            })
        }
        if(poiResult.data.polygon2WKT && !poiResult.data.polygon2WKT.includes('EMPTY')) {
            areas.push({
                area: poiResult.data.polygon2WKT,
                level: 2
            })
        }
        if(poiResult.data.polygon3WKT && !poiResult.data.polygon3WKT.includes('EMPTY')) { 
            areas.push({
                area: poiResult.data.polygon3WKT,
                level: 3
            })
        }
        return areas.length > 0 ? areas : false
    }
    return false;
}

export function getAreaDisplaySettings(poiType, mapGlSupported = true) {  
    let settings

    if(poiType === 'greenzone') {
        if(mapGlSupported) {
            settings = {
                color: '#da2033',
                fillOpacity: [
                    0.25,
                    0.1
                ],
                lineOpacity: [
                    0.6,
                    0.1
                ],
            }
        } else {
            settings = {
                color: '#da2033',
                fillOpacity: {
                    default: 0.1,
                    hover: 0.25
                },
                lineOpacity: {
                    default: 0.2,
                    hover: 0.85
                }
            }
        }
    } else if (poiType === 'shorttermparking') {
        if(mapGlSupported) {
            settings = {
                color: '#0071bb',
                fillOpacity: [
                    [
                        'match',
                        ['get', 'subCategory'],
                        'NON_PUBLIC',
                        0.7,
                        0.25
                    ],
                    [
                        'match',
                        ['get', 'subCategory'],
                        'NON_PUBLIC',
                        0.4,
                        0.2
                    ],
                ],
                lineOpacity: [
                    [
                        'match',
                        ['get', 'subCategory'],
                        'NON_PUBLIC',
                        1,
                        1
                    ],
                    [
                        'match',
                        ['get', 'subCategory'],
                        'NON_PUBLIC',
                        0.6,
                        0.1
                    ],
                ],
            }
        } else {
            settings = {
                color: '#0071bb',
                fillOpacity: {
                    default: 0.2,
                    hover: 0.25
                },
                lineOpacity: {
                    default: 0.3,
                    hover: 1
                },
                categories: {
                    NON_PUBLIC: {
                        fillOpacity: {
                            default: 0.4,
                            hover: 0.7
                        },
                        lineOpacity: {
                            default: 0.6,
                            hover: 1
                        }
                    }
                }
            } 
        }
    } else if(poiType === 'travelRadar') {
        if(mapGlSupported) {
            settings = {
                color: [
                    'case',
                    ['==', ['get', 'subCategory'], 'VERY_HIGH'],
                    '#da2032',
                    ['any',
                        ['==', ['get', 'subCategory'], 'HIGH'],
                        ['==', ['get', 'level'], 3]
                    ],
                    '#da2032',
                    ['any',
                        ['==', ['get', 'subCategory'], 'ELEVATED'],
                        ['==', ['get', 'level'], 2]
                    ],
                    '#fa8000',
                    ['any',
                        ['==', ['get', 'subCategory'], 'LOW'],
                        ['==', ['get', 'level'], 1]
                    ],
                    '#ffdc00',
                    '#ffdc00', // fallback
                ],
                fillOpacity: [
                    0.3,
                    0.3,
                ],
                lineOpacity: [
                    1,
                    1,
                ],
            }
        }
    } else {
        if(mapGlSupported) {
            settings = {
                color: '#000000',
                fillOpacity: [
                    0.25,
                    0.1
                ],
                lineOpacity: [
                    0.6,
                    0.1
                ],
            } 
        } else {
            settings = {
                color: '#000000',
                fillOpacity: {
                    default: 0.1,
                    hover: 0.25
                },
                lineOpacity: {
                    default: 0.35,
                    hover: 0.6
                }
            } 
        }
    }

    return settings
}